import { render } from "./StageRemarketingMix.vue?vue&type=template&id=1df326f2&scoped=true"
import script from "./StageRemarketingMix.vue?vue&type=script&lang=js"
export * from "./StageRemarketingMix.vue?vue&type=script&lang=js"

import "./StageRemarketingMix.vue?vue&type=style&index=0&id=1df326f2&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df326f2"]])

export default __exports__